// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1DhQp","header":"PatientQuestionnaire_header__3Qpyo","info":"PatientQuestionnaire_info__3iKh0"};